import crypto from 'crypto'

const AWS_SECRET_ACCESS_KEY = 'Fkg2naOj8HdtAvpHqs8YuOXT7leRaf9uml2hBQl3'

const config = {
  cryptkey: crypto.createHash('sha256').update(AWS_SECRET_ACCESS_KEY).digest(),
  iv: 'a2xhcgAAAAAAAAAA'
}

export function encryptText (text) {
  var cipher = crypto.createCipheriv('aes-256-cbc', config.cryptkey, config.iv)
  return Buffer.concat([
    cipher.update(text),
    cipher.final()
  ]).toString('base64') // Output base64 string
}

export function decryptText (text) {
  if (text === null || typeof text === 'undefined' || text === '') {
    return text
  }
  var decipher = crypto.createDecipheriv('aes-256-cbc', config.cryptkey, config.iv)
  return Buffer.concat([
    decipher.update(text, 'base64'), // Expect `text` to be a base64 string
    decipher.final()
  ]).toString()
}

export function lambdaAuthHeaders (text) {
  return {
    'X-Lc-Request-Id': text,
    'X-Lc-Security-Token': encryptText(text)
  }
}
